"use strict";

var _regeneratorRuntime = require("/opt/build/repo/app/node_modules/@babel/runtime/regenerator/index.js");

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIndices = void 0;

var react_1 = __importDefault(require("react"));

var useReactifySearchContext_1 = require("./useReactifySearchContext");

var useIndices = function useIndices() {
  var _ref = (0, useReactifySearchContext_1.useReactifySearchContext)(),
      config = _ref.config,
      options = _ref.options;

  var shopName = options.shopifyPermanentDomain.replace(".myshopify.com", "");

  var _react_1$default$useS = react_1.default.useState([]),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      indices = _react_1$default$useS2[0],
      setIndices = _react_1$default$useS2[1];

  var indexNameFormat = function indexNameFormat(indexName) {
    var indexNameFormatted = indexName;

    try {
      var indexDate = indexName.split("".concat(shopName, "-"))[1];
      indexNameFormatted = "".concat(shopName, " ").concat(new Date(parseInt(indexDate)).toLocaleString(), " (").concat(indexDate, ")");
    } catch (error) {
      console.error(error);
    }

    return indexNameFormatted;
  };

  react_1.default.useEffect(function () {
    (function () {
      return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var response, regexp;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch("".concat(config.endpoint, "/_cat/indices?format=json"), {
                  headers: {
                    "x-reactify-index": config.index,
                    "x-reactify-skip-cache": "true"
                  }
                }).then(function (response) {
                  return response.json();
                });

              case 2:
                response = _context.sent;
                regexp = new RegExp("".concat(shopName, "-[0-9]"));
                setIndices(response.map(function (item) {
                  return item.index;
                }).filter(function (item) {
                  return regexp.test(item);
                }).sort(function (a, b) {
                  return a > b ? -1 : 1;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    })();
  }, [config.endpoint]);
  return {
    indices: indices,
    indexNameFormat: indexNameFormat
  };
};

exports.useIndices = useIndices;